export default function(width) {

    this._options.width = width;

    return this;
};
